var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Box, Grid, makeStyles, Paper } from '@material-ui/core';
import { useIsMobile } from '@timeflies/app-ui';
import clsx from 'clsx';
import React from 'react';
import { KeyboardShortcutsHelper } from './keyboard-shortcuts-helper';
import { SpellButton } from './spell-button';
var buttonSizes = {
    main: 56,
    secondary: 48
};
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            position: 'relative',
            backdropFilter: 'blur(2px)'
        },
        background: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            zIndex: -1,
            opacity: 0.5
        },
        mobileFirstButton: {
            marginBottom: -spacing(1),
            marginRight: (buttonSizes.main - buttonSizes.secondary) - spacing(1)
        },
        shortcutsHelperWrapper: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            transform: 'translateY(-100%)'
        }
    });
});
export var SpellButtonPanel = function (_a) {
    var spellsProps = _a.spellsProps, spellList = _a.spellList, defaultSpellId = _a.defaultSpellId;
    var classes = useStyles();
    var isMobile = useIsMobile();
    var spellListWithoutDefault = spellList.filter(function (spellId) { return spellId !== defaultSpellId; });
    var getDesktopContent = function () { return (React.createElement(Grid, { container: true, spacing: 2 }, __spreadArray([defaultSpellId], spellListWithoutDefault).map(function (spellId, index) { return (React.createElement(Grid, { key: spellId, item: true },
        React.createElement(SpellButton, __assign({}, spellsProps[spellId], { index: index, imageSize: buttonSizes.main })))); }))); };
    var getMobileContent = function () {
        var firstLine = spellListWithoutDefault.slice(0, 2);
        var secondLine = [spellListWithoutDefault[2], defaultSpellId];
        return (React.createElement(Grid, { container: true, direction: 'column', spacing: 2 }, [firstLine, secondLine].map(function (line, lineIndex) { return (React.createElement(Grid, { key: lineIndex, item: true, container: true, alignItems: 'flex-end', justify: 'flex-end', spacing: 2 }, line.map(function (spellId, index) {
            var _a;
            return (React.createElement(Grid, { key: spellId, className: clsx((_a = {},
                    _a[classes.mobileFirstButton] = spellId === firstLine[0],
                    _a)), item: true },
                React.createElement(SpellButton, __assign({}, spellsProps[spellId], { index: index, imageSize: spellId === defaultSpellId ? buttonSizes.main : buttonSizes.secondary }))));
        }))); })));
    };
    return (React.createElement(Box, { className: classes.root, position: 'relative', display: 'inline-flex', p: 2, zIndex: 0 },
        React.createElement("div", { className: classes.shortcutsHelperWrapper },
            React.createElement(KeyboardShortcutsHelper, null)),
        React.createElement(Paper, { className: classes.background }),
        isMobile
            ? getMobileContent()
            : getDesktopContent()));
};
